export default "<a target=\"_blank\" [href]=\"tag\">\n  {{tag}}\n</a>\n\n";